import React from 'react';
import classNames from 'classnames';
import { regionHasContent } from './helpers';

const RegionPicker = (props) => {
  const regionClasses = classNames({
    'c-regionalization__region-picker': true,
    'c-regionalization__region-picker--is-visible': props.regionPickerVisible,
  });

  return (
    <div
      id={props.Id}
      className={regionClasses}
      aria-hidden={!props.regionPickerVisible}
    >
      <div className="c-regionalization__region-picker__content">
        <div className="c-regionalization__region-picker__content__inner">
          {props.Options &&
            props.Options.map((option, key) => (
              <Region key={key} {...props} {...option} />
            ))}
        </div>

        {typeof regionHasContent(
          props.currentSelectedRegion,
          props.RegionContent
        ) === 'undefined' && (
          <span className="show-for-sr">
            Välj en region för att visa tillägg
          </span>
        )}

        <button
          type="button"
          className="show-for-sr"
          disabled={
            typeof regionHasContent(
              props.currentSelectedRegion,
              props.RegionContent
            ) === 'undefined'
          }
          onClick={props.handleScreenReaderChangeRegion}
          aria-controls={`content-${props.Id}`}
          aria-expanded={
            typeof regionHasContent(
              props.currentSelectedRegion,
              props.RegionContent
            ) !== 'undefined'
          }
        >
          Visa tillägg
        </button>
      </div>
    </div>
  );
};

const Region = (props) => {
  if (!props.RegionContent) return null;

  const regionClasses = classNames({
    'c-regionalization__region': true,
    'c-regionalization__region--has-content': regionHasContent(
      props.Value,
      props.RegionContent
    ),
    'c-regionalization__region--is-current': props.Selected,
  });

  return (
    <label className={regionClasses}>
      <input
        type="radio"
        name="region"
        onChange={props.handleChangeRegion}
        disabled={!regionHasContent(props.Value, props.RegionContent)}
        value={props.Value}
        defaultChecked={props.Selected}
      />
      <span>
        <span className="c-regionalization__region__label-txt">
          {props.Name}
        </span>
      </span>
    </label>
  );
};

export default RegionPicker;
